import technologyController from '../../../controllers/technologyController/controller';
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';
export default{
    name: 'SimpleTable',
    data() {
        return{
            company: '',
            technologyList: [],
            currentPage: 1,
            pageSize: 10,
            totalTechnologys: 0,
            totalPages: 0,
            allIcons: [],
            dropdownOpen: false,
            icons: [],
            searchQuery: '',
            sizes: [1, 5, 10, 20],
            technology: {
                id: '',
                name : '',
                deskripsi : '',
                language: '',
                icon: '',
                status: '',
                created_by: '',
                created_by_name: '',
                created_on: '',
            },
            selectedTechnology: {
                updated_by: '',
                updated_by_name: '',
            }
        }
    },
    computed:{
        filteredTechnologies() {
            return this.technologyList.filter(technology => {
                return technology.name.toLowerCase().includes(this.searchQuery.toLowerCase());
            })
        },
        pages(){
            return Math.ceil(this.totalTechnologys / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods:{
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.technology.created_by = id;
            this.selectedTechnology.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.technology.created_by_name = name;
            this.selectedTechnology.updated_by_name = name;
        },
        showModal(type, id) {
            this.user();
            const technology = this.technologyList.find(technology => technology.id === id);
            if (technology) {
                this.technology = technology;
                
                const modal = document.getElementById(type === 'edit' ? 'editTechnology' : 'detailTechnology');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
          const modalIds = ['tambahTechnology', 'editTechnology', 'detailTechnology'];
          modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
              modal.classList.remove('show');
              setTimeout(() => {
                modal.style.display = 'none';
              }, 300);
            }
          });
        
          // Hapus backdrop
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
              if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
              }
            }, 300);
          });
        
          // Hapus kelas atau atribut yang mengunci scroll pada body
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.overflow = ''; // Menghapus properti overflow jika ada
          this.fetchTechnology();
          this.resetForm();
          this.user();
        },    
        resetForm() {
            this.technology.name = '';
            this.technology.deskripsi = '';
            this.technology.icon = '';
            this.technology.language = '';
            this.technology.status = '';
            this.iconSearch = '';
            this.icon();
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchTechnology();
            }
        },
        async fetchTechnology() {
            try{
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await technologyController.fetchTechnology(query, this.currentPage, this.pageSize, company);
                this.technologyList = response.data;
                this.totalAllTechnology();
            } catch (error){
                console.error('Error fetching technology:', error);
            }
        },

        async totalAllTechnology() {
            try{
                const company = this.company;
                const response = await technologyController.totalAllTechnology(company);
                this.totalTechnologys = response.data;
            } catch (error){
                console.error('Error fetching technology:', error);
            }
        },
        async addTechnology() {
            try{
            const name = this.technology.name;
            const deskripsi = this.technology.deskripsi;
            const icon = this.technology.icon;
            const language = this.technology.language;
            const company = this.company;
            const status = this.technology.status;
            const created_by = this.technology.created_by;
            const created_by_name = this.technology.created_by_name;
            const now = new Date();
            const created_on = now.toISOString().slice(0, 19).replace('T', ' ');
            if (!name || !deskripsi || !icon || !language || !status || !created_by || !created_by_name) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal menambahkan data',
                    text: 'Isi semua field!!',
                    timer: 1500
                })
                return;
            }
            const add = {
                name: name,
                description: deskripsi,
                icon: icon,
                is_active: status,
                language: language,
                id_company: company,
                created_by: created_by,
                created_by_name: created_by_name,
                created_on: created_on
            }
            const response = await technologyController.addTechnology(add);
            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil menambahkan data',
                    timer: 1500
                })
                this.closeModal();
                this.fetchTechnology();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal menambahkan data',
                    timer: 1500
                })
                return;
            }
            } catch(error){
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal menambahkan data',
                    timer: 1500
                })
            }
        },
        async updateTechnology() {
            try{
                const id = this.technology.id;
                const name = this.technology.name;
                const deskripsi = this.technology.deskripsi;
                const language = this.technology.language;
                const icon = this.technology.icon;
                const status = this.technology.status;
                const updated_by = this.selectedTechnology.updated_by;
                const updated_by_name = this.selectedTechnology.updated_by_name;
                const now = new Date();
                const updated_on = now.toISOString().slice(0, 19).replace('T', ' ');
                if (!name || !deskripsi || !icon || !language || !status || !updated_by || !updated_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal mengupdate data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                    return;
                }
                const update = {
                    id: id,
                    name: name,
                    description: deskripsi,
                    language: language,
                    icon: icon,
                    is_active: status,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    updated_on: updated_on
                }
                const response = await technologyController.updateTechnology(update);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Data berhasil diperbaharui',
                        showConfirmButton: false,
                        timer: 1500
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Data gagal diperbaharui',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
                this.closeModal();
                this.fetchTechnology();
            } catch(error){
                Swal.fire({
                    icon: 'error',
                    title: 'Data gagal diperbaharui',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        },
        async deleteTechnology(id) {
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try{
                    await technologyController.deleteTechnology(id);
                    Swal.fire({
                        icon: 'success',
                        title: 'Data berhasil dihapus',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.fetchTechnology();
                } catch(error){
                    Swal.fire({
                        icon: 'error',
                        title: 'Data gagal dihapus',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        },
        async icon(){
            const res = await fetch('https://raw.githubusercontent.com/twbs/icons/main/font/bootstrap-icons.json');
            const data = await res.json();
            this.allIcons = Object.keys(data).map(name => `bi bi-${name}`);
            this.icons = this.allIcons;
        },
        selectIcon(icon) {
            this.technology.icon = icon;
            this.dropdownOpen = false;
        },
        searchIcon() {
            const keyword = this.iconSearch.toLowerCase();
            this.icons = this.allIcons.filter(icon =>
                icon.toLowerCase().includes(keyword)
            );
        }
    },
    mounted() {
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
        this.icon();
        this.icons = this.allIcons; 
    },
    watch: {
        searchQuery: {
            handler: 'fetchTechnology'
        },
        company: {
            handler: 'fetchTechnology'
        }
    },
    created() {
        this.icons = this.allIcons; // Awal: tampilkan semua
    },
}